import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleTomorrowForecastHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type TomorrowsForecastCardProps = {
  titleHref: string
  forecast: HuddleDashboard['tomorrowForecastApi']
  className?: string
}

export function TomorrowsForecastCard({
  titleHref,
  forecast,
  className = 'dashboard-huddle-forecast-card dashboard-huddle-full-row dashboard-huddle-tomorrow-forecast-row',
}: TomorrowsForecastCardProps): React.ReactElement {
  const { summaryMetrics, loading, data } = forecast
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleTomorrowForecastHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Tomorrow's forecast"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={summaryMetrics} />
    </DashboardSectionCard>
  )
}
